module.exports = __webpack_public_path__ + "media/maps-markers/blue-pin-d2237f0f.svg";